import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let sectorsSwiperWr = document.querySelectorAll('.sectors-swiper-wr');

const sectorsTabsArr = document.querySelectorAll('.sectors-section__tab');
sectorsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 20,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        425: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        640: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        1024: {
          spaceBetween: 24,
          slidesPerView: 3,
        },
        1200: {
          spaceBetween: 52,
          slidesPerView: 3,
        },
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      on: {
        afterInit: function () {
          wrapper.scrollWidth >= wrapper.clientWidth
            ? wrapper.classList.remove('justify-center')
            : wrapper.classList.add('justify-center');
        },

        resize: function () {
          wrapper.scrollWidth >= wrapper.clientWidth
            ? wrapper.classList.remove('justify-center')
            : wrapper.classList.add('justify-center');
        },
      },
    });
    swiperObserver(swiper);
  }
});

if (sectorsTabsArr.length) {
  sectorsTabsArr.forEach((tabEl, tadIdx) => {
    tabEl.addEventListener('click', () => {
      if (!tabEl.classList.contains('active')) {
        for (let i = 0; i < sectorsTabsArr.length; i++) {
          sectorsTabsArr[i].classList.remove('active');
          sectorsSwiperWr[i].classList.remove('active');
        }

        tabEl.classList.add('active');
        sectorsSwiperWr[tadIdx].classList.add('active');
      }
    });
  });
}
